var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Header"},[_c('img',{staticClass:"img-fluid",attrs:{"src":require("../assets/BIOND.png"),"alt":"Responsive image"}})])}]

export { render, staticRenderFns }